export default "__VITE_ASSET__22b0b73d__"